import type { HostingPleskDomainView } from '@tosho/contracts';
import { HostingPleskSiteStatus } from '@tosho/domain';
import { PrototypeIcon, type PrototypeIconName } from './PrototypeIcon';
const labels = {
  ACTIVE: 'Actif',
  INACTIVE: 'Site désactivé',
  MAINTENANCE: 'Sauvegarde / restauration',
  UNKNOWN: 'État Plesk non lu',
} as const;
const icons: Record<keyof typeof labels, PrototypeIconName> = {
  ACTIVE: 'check',
  INACTIVE: 'circle-alert',
  MAINTENANCE: 'history',
  UNKNOWN: 'circle-help',
};
export function HostingSitePleskStatus({
  value,
  inventoryObservedAt,
}: {
  readonly value:
    | HostingPleskDomainView['technicalSummary']
    | HostingPleskDomainView['statusSummary'];
  readonly inventoryObservedAt?: string;
}): React.JSX.Element {
  const status = new HostingPleskSiteStatus(value?.statusCode).kind;
  return (
    <div className="hosting-site-status">
      <span className={'hosting-site-status__badge is-' + status.toLowerCase()}>
        <PrototypeIcon name={icons[status]} />
        {status === 'UNKNOWN' && value ? 'État Plesk inconnu' : labels[status]}
      </span>
      {value ? (
        <small>
          {value.accessIsCurrent ? 'État lu' : 'État historique'} le{' '}
          {new Date(value.observedAt).toLocaleString('fr-FR')}
        </small>
      ) : null}
      {inventoryObservedAt &&
      (!value || Date.parse(inventoryObservedAt) !== Date.parse(value.observedAt)) ? (
        <small>Inventaire du {new Date(inventoryObservedAt).toLocaleString('fr-FR')}</small>
      ) : null}
    </div>
  );
}

export function siteStatusObservation(
  domain: HostingPleskDomainView,
): HostingPleskDomainView['statusSummary'] | HostingPleskDomainView['technicalSummary'] {
  return domain.statusSummary &&
    (!domain.technicalSummary ||
      Date.parse(domain.statusSummary.observedAt) >= Date.parse(domain.technicalSummary.observedAt))
    ? domain.statusSummary
    : domain.technicalSummary;
}
